export class LoginViewModel {
  get loginId(): string {
    return this._loginId;
  }

  set loginId(value: string) {
    this._loginId = value;
  }

  get password(): string {
    return this._password;
  }

  set password(value: string) {
    this._password = value;
  }

  get ip(): string {
    return this._ip;
  }

  set ip(value: string) {
    this._ip = value;
  }

  get applicationId(): string {
    return this._applicationId;
  }

  set applicationId(value: string) {
    this._applicationId = value;
  }
  private _loginId: string = '';
  private _password: string = '';
  private _ip: string = '';
  private _applicationId: string = '';
}
